import { delayUpdate } from './utils';

export class Share {
  constructor(node, classNamePrefix = '.pdp-c') {
    this.node = node;
    this.shareAreaText = this.node.querySelector(`${classNamePrefix}-share__link`);
    this.copyBtn = this.node.querySelector(`${classNamePrefix}-share__copy-btn`);
    this.timer = undefined;
  }

  init() {
    // Bind event listeners
    this.copyBtn.addEventListener('click', this.#handleClick.bind(this));
    this.shareAreaText.addEventListener('focus', this.#handleFocus.bind(this));
  }

  setContent(url) {
    this.shareAreaText.value = url;
    return this;
  }

  #copyToClipboard(textContent) {
    navigator.clipboard
      .writeText(textContent)
      .then(() => {
        this.timer = delayUpdate(this.copyBtn, {
          text: 'Copied!',
          previousText: 'Copy Url',
          ms: 1000,
          timerId: this.timer,
        });
      })
      .catch((error) => console.error(error.message));
  }

  #handleClick() {
    const textContent = this.shareAreaText?.value;

    if (textContent) {
      this.#copyToClipboard(textContent);
    }
  }

  #handleFocus() {
    this.shareAreaText.select();
    const textContent = this.shareAreaText?.value;

    if (textContent) {
      this.#copyToClipboard(textContent);
    }
  }

  close() {
    this.shareAreaText.removeEventListener('focus', this.#handleFocus.bind(this));
    this.copyBtn.removeEventListener('click', this.#handleClick.bind(this));
  }
}
